
import { ClassFlag } from "../../../../../library-js/dom-tools/ClassFlag";
import { ElementType } from "../../../../../library-js/dom-tools/ElementType";
import { OnClick } from "../../../../../library-js/dom-tools/EventListeners";
import { deepClone } from "../../../../../library-js/tools/TypeUtilities";
import { DomElement } from "../../../../../library/ts/html/dom/DomElement";
import { Rokojori } from "../../../../js/Rokojori";
import { MailEntry } from "../app/data/MailEntry";
import { ReminderEntry, ReminderEntryType } from "../app/data/ReminderEntry";
import { ReminderApp } from "../app/ReminderApp";
import { ReminderButton } from "./reminder-button";
import { ReminderUI } from "./reminder-ui";


export class ReminderMain extends DomElement<HTMLElement>
{ 
  static type = new ElementType( "reminder-main" );
  static activeEntries = new ElementType( "active-entries" );

  _buttons:ReminderButton[];
  get buttons(){ return this._buttons; }

  _getButton( flag:ClassFlag )
  {
    return this.buttons.find( b => flag.in( b.element ) );
  }

  get mailButton(){ return this._getButton( ReminderButton.mail ); }
  get clockButton(){ return this._getButton( ReminderButton.clock ); }
  get calenderButton(){ return this._getButton( ReminderButton.calender ); }


  constructor( e:HTMLElement )
  {
    super( e );

    this._buttons = this.getAll( ReminderButton );
  }


  loadEntries( entries:ReminderEntry[], ui:ReminderUI)
  {
    let activeEntriesElement = ReminderMain.activeEntries.query( this.element );
    activeEntriesElement.innerHTML = "";
    let reminderApp = ui.app;

    entries.forEach(
      ( e )=>
      {
        let name = "";

        let isMailEntry = ReminderEntryType.Mail == e.type;
        let mailEntry:MailEntry = null;
        

        if ( isMailEntry )
        {
          mailEntry = e as MailEntry
          name = mailEntry.date + " " + mailEntry.subject;
        }

        let entry = new ElementType( "reminder-button" ).create( name );
        let typeName = ReminderEntryType[ e.type ];
        new ClassFlag( typeName.toLowerCase() ).set( entry );
        entry = Rokojori.$.processRawTemplateElement( entry );
        activeEntriesElement.appendChild( entry );

        OnClick.add( entry as HTMLElement, 
          ( ev )=>
          {       
            if ( isMailEntry )
            {
              reminderApp._editMailEntry = deepClone( mailEntry );
              ui._reminderMailView.setEntry( reminderApp._editMailEntry );
              ui.setActiveWindow( ui._reminderMailView );
              ui._reminderMailView.setEntry( reminderApp._editMailEntry );
            }      

          }
        );
        
      }
    );
  }
  
}